





















import { defineComponent, PropType, ref } from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import BaseIcon from "@/components/BaseIcon";
import ViewersList from "../ViewersList";

export default defineComponent({
  name: "StreamViewersController",
  components: { ViewersList, BaseIcon },
  props: {
    canViewList: { type: Boolean, required: true },
    userList: { type: Array as PropType<LiveChatUser[]>, required: true },
    isOwner: { type: Boolean, required: true },
    moderatorIds: { type: Array as PropType<string[]>, default: () => [] },
    streamingUserIds: { type: Array as PropType<string[]>, default: () => [] },
  },
  setup(props) {
    const showViewers = ref(false);

    const handleShowViewers = () => {
      if (!props.canViewList) return;
      showViewers.value = !showViewers.value;
    };

    return { showViewers, handleShowViewers };
  },
});
